import type { SVGProps } from 'react';

const SvgRa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M14.16 8.21c-.47-.7-1.26-1.12-2.1-1.12h-1.04V5.22a2.27 2.27 0 0 0-3.41-1.97c-.56.33-.96.88-1.1 1.57l-.14.81c-.38 1.91-.65 2.38-1.38 2.38-1.1 0-2 .9-2 2v2.97c0 1.65 1.35 3 3 3h3.66c1.32 0 2.43-.77 3.02-2.08l1.73-3.47c.29-.72.2-1.55-.25-2.22zm-3.28 4.83c-.19.43-.56.94-1.21.94H6.01c-.55 0-1-.45-1-1v-2.97c2.54 0 3.02-2.4 3.34-3.98l.09-.44s0-.04.01-.06l.05-.36c.02-.1.08-.15.13-.18.03-.02.08-.04.14-.04.03 0 .06 0 .09.01.11.04.19.14.19.26v2.12c0 .96.78 1.75 1.75 1.75h1.29c.2 0 .36.12.44.24.06.08.11.21.08.28l-1.71 3.43zM18 7.95h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1 .45 1 1v2.97c-2.54 0-3.02 2.4-3.34 3.98l-.15.85c-.02.1-.08.16-.13.18-.05.03-.13.05-.22.02a.28.28 0 0 1-.19-.26v-2.12c0-.55-.45-1-1-1s-1 .45-1 1v2.12c0 .98.62 1.85 1.55 2.16.23.08.48.12.72.12.4 0 .79-.1 1.14-.31.56-.33.96-.88 1.1-1.57l.15-.81c.38-1.91.65-2.38 1.38-2.38 1.1 0 2-.9 2-2v-2.97c0-1.65-1.35-3-3-3z"
    />
  </svg>
);
export default SvgRa;
